import { render, staticRenderFns } from "./LoginAttemptsWarning.vue?vue&type=template&id=02b8520e&scoped=true&"
import script from "./LoginAttemptsWarning.vue?vue&type=script&lang=js&"
export * from "./LoginAttemptsWarning.vue?vue&type=script&lang=js&"
import style0 from "./LoginAttemptsWarning.vue?vue&type=style&index=0&id=02b8520e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b8520e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
